import env from 'pages/MyAccount/utils/env';
import { flattenProductArray } from 'pages/MyAccount/utils/apiMiddleware/apiMiddleware';
import request from './request';

export function createCampaign(formData) {
  const requestUrl = `${env.aceApi}api/1/campaigns`;
  const data = JSON.stringify(formData);
  return request(
    requestUrl,
    'POST',
    { 'Content-Type': 'application/json' },
    data
  );
}

export function updateCampaign(formData) {
  const requestUrl = `${env.aceApi}api/1/campaigns`;
  const data = JSON.stringify(formData);
  return request(
    requestUrl,
    'PUT',
    { 'Content-Type': 'application/json' },
    data
  );
}

export const getCampaigns = () => request(`${env.aceApi}api/1/campaigns/all`);

export const getProductsByCampaignId = async (id) => {
  const response = await request(
    `${env.aceApi}api/1/campaigns/${id}/product-bundles`
  );
  const variants = flattenProductArray(response);
  return { products: response, variants };
};

export const updateProducts = async (campaignId, productsToUpdate) => {
  const requestUrl = `${env.aceApi}api/1/campaigns/${campaignId}/product-bundles`;
  const data = JSON.stringify(productsToUpdate);
  const response = await request(
    requestUrl,
    'PUT',
    { 'Content-Type': 'application/json' },
    data
  );
  const variants = response.success ? flattenProductArray(response.value) : [];
  const error = response.success ? '' : response.message;
  return { updatedProducts: response.value, variants, error };
};

export function postSkusToCampaign(id, formData) {
  const requestUrl = `${env.aceApi}api/1/campaigns/${id}/skus`;
  const data = JSON.stringify(formData);
  return request(
    requestUrl,
    'POST',
    { 'Content-Type': 'application/json' },
    data
  );
}

export function setDefaultCampaign(campaignId) {
  const requestUrl = `${env.aceApi}api/1/campaigns/${campaignId}/default?override=true`;
  return request(requestUrl, 'POST', {}, {});
}

export function deleteProductCacheByCampaignId(campaignId) {
  const requestUrl = `${env.aceApi}api/1/campaigns/${campaignId}/cache`;
  return request(requestUrl, 'DELETE', {}, {});
}
